import { CandidateAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';
import { IGetCandidateListPayload, IGetCandidateListResult } from '../types';

export const getCandidateList = async (
  payload: IGetCandidateListPayload,
): Promise<IGetCandidateListResult> => {
  const response = await PermanentJobsApi.getCandidateList(payload);

  return CandidateAdapters.toGetCandidateListResult(response);
};
